import React from 'react';
import { IconButton, Badge, Tooltip, keyframes } from '@mui/material';
import { Phone as PhoneIcon } from '@mui/icons-material';
import { useWebPhoneContext } from '../../contexts/WebPhoneContext';

const pulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(76, 175, 80, 0);
  }
`;

const shake = keyframes`
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-15deg);
  }
  75% {
    transform: rotate(15deg);
  }
`;

const WebPhoneButton: React.FC = () => {
  const {
    isWindowOpen,
    connectionStatus,
    callStatus,
    openWindow,
    closeWindow
  } = useWebPhoneContext();

  const handleClick = () => {
    if (isWindowOpen) {
      closeWindow();
    } else {
      openWindow();
    }
  };

  const isConnected = connectionStatus === 'connected' || connectionStatus === 'registered';
  const isRinging = callStatus === 'ringing';
  const isInCall = callStatus === 'in-call';

  const getTooltip = () => {
    if (isInCall) return 'In Call - Click to view';
    if (isRinging) return 'Incoming Call!';
    if (isConnected) return 'WebPhone - Ready';
    return 'WebPhone - Disconnected';
  };

  const getBadgeColor = () => {
    if (isRinging) return 'warning';
    if (isInCall) return 'primary';
    if (isConnected) return 'success';
    return 'error';
  };

  return (
    <Tooltip title={getTooltip()}>
      <IconButton
        onClick={handleClick}
        sx={{
          color: isWindowOpen ? 'primary.main' : 'inherit',
          animation: isRinging ? `${shake} 0.5s infinite` : isConnected ? `${pulse} 2s infinite` : 'none',
          '&:hover': {
            bgcolor: 'action.hover',
          },
        }}
      >
        <Badge
          variant="dot"
          color={getBadgeColor()}
          invisible={!isConnected && !isRinging && !isInCall}
        >
          <PhoneIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default WebPhoneButton;
